import { ChartInfoItemContent } from './chart-info.models';

export const kpiItemNumber: ChartInfoItemContent = {
  titleTop: 'Lowest',
  titleBottom: 'String 1.3',
  valueZip: { id: '1', value: 90.84235984300855 },
  measurand: '%',
  numberFormat: '1.0-2',
};

export const kpiItemWithoutTitleBottom: ChartInfoItemContent = {
  titleTop: 'Spread',
  valueZip: { id: '1', value: 90.84235984300855 },
  measurand: '%',
  numberFormat: '1.0-2',
};

export const kpiItemDate: ChartInfoItemContent = {
  titleTop: 'Highest',
  titleBottom: 'String 1.3',
  valueZip: { id: '1', value: 2145502440000 },
  dateFormat: 'MMM d, y',
};
